import { useEffect, useMemo, useState } from 'react';
import { Button, Flex, Select, Tooltip, Typography } from 'antd';

const { Text } = Typography;

type TriState = 'yes' | 'no';

const toTriState = (value: boolean | undefined): TriState =>
	value ? 'yes' : 'no';

const fromTriState = (value: TriState): boolean => value === 'yes';

export type ProductionBooleanSelectProps = {
	label: string;
	value: boolean | undefined;
	disabled?: boolean;
	saving?: boolean;
	tooltip?: string;
	onSave: (value: boolean) => void | Promise<void>;
};

const ProductionBooleanSelect = ({
	label,
	value,
	disabled,
	saving,
	tooltip,
	onSave,
}: ProductionBooleanSelectProps) => {
	const saved = useMemo(() => toTriState(value), [value]);
	const [draft, setDraft] = useState<TriState>(saved);

	useEffect(() => {
		setDraft(saved);
	}, [saved]);

	const dirty = draft !== saved;

	const row = (
		<Flex align="center" gap="small" wrap="wrap">
			<Text style={{ minWidth: 220 }}>{label}</Text>
			<Select<TriState>
				value={draft}
				disabled={disabled}
				style={{ width: 220 }}
				options={[
					{ value: 'no', label: 'No' },
					{ value: 'yes', label: 'Yes' },
				]}
				onChange={setDraft}
				aria-label={label}
			/>
			{dirty && (
				<Button
					type="primary"
					loading={saving}
					disabled={disabled || saving}
					onClick={() => onSave(fromTriState(draft))}
				>
					Save
				</Button>
			)}
		</Flex>
	);

	if (tooltip) {
		return <Tooltip title={tooltip}>{row}</Tooltip>;
	}

	return row;
};

export default ProductionBooleanSelect;
